module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/load_data_en-8e9e00021334be734b73685636cde215.gif";